import noScroll from "no-scroll";
import { useEffect, useState } from "react";
import { FaEye, FaPencilAlt, FaTimes } from "react-icons/fa";
import { Modal } from "reactstrap";
import useWindowDimensions from "../Dimension/Dimension";
import ToggleSold from "../Toggle/ToggleSold";
import SingleItem from "./SingleItem";

const ItemList = ({ product, onProductEdit, isApproved }) => {
  const { width } = useWindowDimensions();

  const [itemPopup, setItemPopup] = useState(false);
  const desc = product && product.desc;

  useEffect(() => {
    if (itemPopup) {
      noScroll.on();
    } else {
      noScroll.off();
    }
    return () => noScroll.off();
  }, [itemPopup]);

  return (
    // console.log(product && JSON.parse(JSON.stringify(product.images))[0]),
    <>
      {product && (
        <div
          style={{ position: "relative" }}
          className="cursor-pointer col-12 d-flex justify-content-between p-1 mb-1 bg-white rounded shadow-sm border"
        >
          <div>
            <div
              onClick={() => {
                setItemPopup(true);
              }}
              className="col d-flex"
            >
              <img
                alt="img"
                style={{ height: "25vh", width: "20vh", objectFit: "cover" }}
                src={
                  product?.images[0] && product?.images[0] !== null
                    ? Object.values(product?.images[0])[0]
                    : "/assets/images/logo.png"
                }
              />
              <div className="ms-1 ms-md-3">
                <p className="item-list-title mb-0" style={{ fontWeight: 600 }}>
                  {product.name}
                </p>
                <p className="section-trail mb-0 ">
                  Rs. {parseInt(product.price)}{" "}
                </p>
                <p className="mb-1 item-list-extra" style={{ fontWeight: 500 }}>
                  {product.category_name}
                </p>
                <p className="mb-1 item-list-extra" style={{ fontWeight: 500 }}>
                  {product.date_of_purchase}
                </p>
                <p className="item-list-extra mb-0">
                  {desc.length > (width < 750 ? 100 : 150)
                    ? desc.substring(0, width < 750 ? 100 : 150) + ". . ."
                    : desc}
                </p>
                <div className="d-flex mt-1 mb-1">
                  <p
                    className={`bg-warning rounded me-2 d-block px-2 py-1 text-white item-list-extra mb-1`}
                  >
                    {width < 750
                      ? product.gender.toUpperCase()
                      : product.gender === "m"
                        ? "Male"
                        : product.gender === "f"
                          ? "Female"
                          : "Unisex"}
                  </p>
                  <p
                    className={`bg-${product.is_refundable === "1" ? "success" : "danger"
                      } rounded me-2 d-block px-2 py-1 text-white item-list-extra mb-1`}
                  >
                    {product.is_refundable === "1"
                      ? ""
                      : width < 750
                        ? "N"
                        : "Non-"}
                    {width < 750 ? "R" : "Refundable"}
                  </p>
                  <p
                    className={`bg-${product.is_exchangeable === "1" ? "success" : "danger"
                      } rounded me-2 d-block px-2 py-1 text-white item-list-extra mb-1`}
                  >
                    {product.is_exchangeable === "1"
                      ? ""
                      : width < 750
                        ? "N"
                        : "Non-"}
                    {width < 750 ? "E" : "Exchangable"}
                  </p>
                </div>
                {isApproved ? (
                  <ToggleSold
                    productId={product.id}
                    isSold={
                      isApproved && product.is_sold === "0" ? false : true
                    }
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
            <p className="small text-danger">
              {product.remarks && product.remarks !== "" && (
                <>
                  <span className="fw-bold">Reason for rejection:</span>{" "}
                  {product.remarks}
                </>
              )}
            </p>
          </div>

          <div
            className="d-flex"
            style={{ position: "absolute", top: 10, right: 20 }}
          >
            <ActionButton background="#066f8a" onClick={() => { }}>
              <FaEye size={16} color="#fff" />
            </ActionButton>
            <ActionButton
              background="#ff0000"
              className="ms-1"
              onClick={(e) => {
                e.stopPropagation();
                onProductEdit(product, product.images);
              }}
            >
              <FaPencilAlt size={16} color="#fff" />
            </ActionButton>
          </div>

          <Modal className="sc-modal" size="xl" isOpen={itemPopup} centered>
            <div
              onClick={() => {
                setItemPopup(false);
              }}
              className="position-absolute cursor-pointer"
              style={{ zIndex: 10, top: 0, right: 10 }}
            >
              <FaTimes size={20} />
            </div>
            <div className="my-4 mx-3">
              <SingleItem
                showSeller={false}
                clsName="col-12"
                product={product}
                images={product.images}
                isApproved={isApproved}
              />
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

export default ItemList;

const ActionButton = ({ children, background, className, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`cursor-pointer d-flex justify-content-center align-items-center p-1 ${className}`}
      style={{ height: 30, width: 30, borderRadius: 15, background }}
    >
      {children}
    </div>
  );
};
